/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type QuotationType = 'Undefined' | 'Day' | 'Month'| 'Year';

export const QuotationType = {
    Undefined: 'Undefined' as QuotationType,
    Day: 'Day' as QuotationType,
    Month: 'Month' as QuotationType,
    Year: 'Year' as QuotationType
};